import React, { Component } from 'react';
import Typography from 'material-ui/Typography';
import Blockie from './Blockie';
import withSubscription from './withSubscription';
import context from './api/context';

class AccountDisplay extends Component {
  render() {
    const { account } = this.props;

    return (
      <div style={{display:'flex'}}>
      <Typography variant="subheading" color="inherit">
        {account.account}
        &nbsp;
        &nbsp;
      </Typography>
      <Blockie circle address={account.account}/>
      </div>
    );
  }
}

export default withSubscription(() => ({ account: context.account }))(AccountDisplay)


// WEBPACK FOOTER //
// ./src/AccountDisplay.js